function getAngleCompass(pois, location, currentOrder) {
  let poi = pois.find((e) => e.order == currentOrder);
  let poiLocation = [parseFloat(poi.location[0]), parseFloat(poi.location[1])];
  let angle =
    (Math.atan2(poiLocation[1] - location[1], poiLocation[0] - location[0]) *
      180) /
    Math.PI;
  console.log("====================================");
  console.log(location);
  console.log(poi.location);
  console.log("====================================");
  return angle;
}

export default getAngleCompass;
